import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions, Response, Http } from '@angular/http';

@Injectable()
export class AuthService {

  private _setToken(token: string): boolean {
    if(localStorage && localStorage.setItem(environment.jwtName, token)) {
      return true;
    } else {
      return false;
    }
  }

  constructor(
    private _http: Http
  ) { }

  hasToken(): boolean {
    if(localStorage && localStorage.getItem(environment.jwtName)) {
      return true;
    } else {
      return false;
    }
  }

  clearToken(): boolean {
    localStorage.removeItem(environment.jwtName);
    localStorage.removeItem(environment.jwtName+'user');
    return true;
  }

  getToken(): string {
    return localStorage.getItem(environment.jwtName);
  }

  loginUser(u: string, p: string) {
    let url = `${environment.apiUrl}login`;
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let body = JSON.stringify({
        username: u,
        password: p
      });
    return this._http.post(url, body, options)
      .map( (resp: Response) => resp.json() )
      .do( obj => {
        this._setToken(obj.jwt);
        localStorage.setItem(environment.jwtName+'user', JSON.stringify(obj.user));
      })
      .catch( (error: any) =>  Observable.throw('Error'))
  }

  verifyToken() {
    let url = `${environment.apiUrl}verify`;
    let headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+this.getToken()
    });
    let options = new RequestOptions({ headers: headers });
    return this._http.post(url, null, options)
      .map( (resp: Response) => {
        return true;
      })
      .catch( (error: any) =>  {
        return Observable.of(false)
      })
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem(environment.jwtName+'user'));
  }



}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts